import ClusterLegs from './ClusterLegs';

export default ClusterLegs;
